import { render, staticRenderFns } from "./ImportAlumniProfile.vue?vue&type=template&id=70f95f5e&"
import script from "./ImportAlumniProfile.vue?vue&type=script&lang=js&"
export * from "./ImportAlumniProfile.vue?vue&type=script&lang=js&"
import style0 from "./ImportAlumniProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports